import React from "react";
import { FaChartLine, FaClinicMedical, FaMobileAlt } from "react-icons/fa";
import { featurePillars } from "../data/siteData";

const featureIcons = [FaClinicMedical, FaMobileAlt, FaChartLine];

function FeaturesSection() {
  return (
    <section id="features" className="section features">
      <div className="features__head">
        <p className="eyebrow center">What byond care does</p>
        <h2 className="center">Everything your clinic needs. In one place.</h2>
        <p className="center">
          Queue management, EMR, billing, pharmacy and analytics in one connected
          platform.
        </p>
      </div>
      <div className="features__grid">
        {featurePillars.map((item, index) => {
          const Icon = featureIcons[index] || FaClinicMedical;
          return (
            <article className="features__card" key={item.title}>
              <div className="features__icon">
                <Icon />
              </div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FeaturesSection;
